/*
Monthly / yearly switch on the membership page.

Ghost gives each tier both prices, so both are rendered and one is hidden
rather than fetched. The CTA carries a Portal URL for each period and
swaps between them, so the reader lands on the checkout they chose.
*/

export default function billing() {
    const options = Array.from(document.querySelectorAll('[data-billing]'));
    if (!options.length) return;

    function show(period) {
        options.forEach((o) => {
            o.setAttribute('aria-pressed', String(o.dataset.billing === period));
        });

        document.querySelectorAll('[data-billing-show]').forEach((el) => {
            el.hidden = el.dataset.billingShow !== period;
        });

        document.querySelectorAll('[data-billing-cta]').forEach((cta) => {
            const href = cta.dataset['href' + period[0].toUpperCase() + period.slice(1)];
            if (href) cta.setAttribute('href', href);
        });
    }

    options.forEach((o) => o.addEventListener('click', () => show(o.dataset.billing)));
    show('monthly');
}
